import { REACT_APP_IMG } from '../../../common/config'
import { REACT_APP_API } from '../../config'
import axios from 'axios'
import { loadWebSignForVerificationForClientPDF } from '../../../features/peritador/webSign/loadWebSignForVerificationForClientPDF'

export async function getVerificationPdf(
  requestId,
  verificationStatusId,
  isForClient = false,
  webSignConfigVerificationForClientPDF = null
) {
  const url = new URL(
    `${REACT_APP_API}/PDF/generateVerificationPDF/${requestId}/${verificationStatusId}`,
    window.location.href
  )

  if (isForClient) {
    url.searchParams.set('isForClient', isForClient)
  }
  const response = await axios.post(url.href, null, { responseType: 'text/html' })

  
  if (!response.data) return null

  if (response.data.hasPDFSigned) {
    const signedPdfUrl = `${REACT_APP_IMG}/${encodeURIComponent(response.data.url)}`
    return window.open(signedPdfUrl, '_blank')
  }

  const html = typeof response.data === 'string' ? response.data : String(response.data)
  const storageKey = `asofix_verif_pdf_${requestId}_${verificationStatusId}_${Date.now()}`
  try {
    sessionStorage.setItem(storageKey, html)
  } catch (e) {
    console.error('[getVerificationPdf] sessionStorage lleno o no disponible', e)
    return null
  }

  const qs = new URLSearchParams({ sk: storageKey })
  if (isForClient) qs.set('client', '1')
  const previewUrl = `${window.location.origin}/peritador/verification-pdf/${requestId}/${verificationStatusId}?${qs}`

  const w = window.open(previewUrl, '_blank')
  if (!w) return null

  if (webSignConfigVerificationForClientPDF) {
    // si refrescan la ventana, el lápiz vuelve a aparecer
    let tries = 0
    const maxTries = 400

    let stableOk = 0

    const t = window.setInterval(() => {
      tries++

      if (!w || w.closed) {
        window.clearInterval(t)
        return
      }

      try {
        const ok = loadWebSignForVerificationForClientPDF(w, isForClient, webSignConfigVerificationForClientPDF, requestId)

        // si ya cargo, se espera antes de cortar
        if (ok) stableOk++
        else stableOk = 0

        if (stableOk >= 40) { //6 segundos
          window.clearInterval(t)
          return
        }
      } catch (e) {
        console.error('[WebSign] error cargando handler', e)
      }

      if (tries >= maxTries) {
        window.clearInterval(t)
      }
    }, 150)

    try {
      loadWebSignForVerificationForClientPDF(w, isForClient, webSignConfigVerificationForClientPDF, requestId)
    } catch (e) {
      console.error('[WebSign] error inicial al inyectar lápiz', e)
    }
    return true
  }

  return true
}